import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchApi } from "Config/fetchApi";
import { handleError } from "Helper";

// Initial state
const initialState = {
  jurisdictionList: {
    dataJurisdictionList: [],
    isLoadingJurisdictionList: false,
    errorJurisdictionList: null,
  },
};

// Thunk action for fetching jurisdiction list
export const getJurisdictionList = createAsyncThunk(
  "jurisdiction/getJurisdictionList",
  async ({ page = 0, size = 99 } = {}, { rejectWithValue }) => {
    try {
      const api = fetchApi(); 
      const url = `/jurisdiction-level/get-list`;
      const result = await api.get(url);
      return result?.data?.data;
    } catch (error) {
      handleError(error)
      console.error(error);
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

// Slice definition
const jurisdictionSlice = createSlice({
  name: "jurisdiction",
  initialState,
  reducers: {
    setJurisdictionList: (state, action) => {
      state.jurisdictionList.dataJurisdictionList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getJurisdictionList.pending, (state) => {
        state.jurisdictionList.isLoadingJurisdictionList = true;
        state.jurisdictionList.errorJurisdictionList = null;
      })
      .addCase(getJurisdictionList.fulfilled, (state, action) => {
        state.jurisdictionList.isLoadingJurisdictionList = false;
        state.jurisdictionList.dataJurisdictionList = action.payload || [];
        state.jurisdictionList.errorJurisdictionList = null;
      })
      .addCase(getJurisdictionList.rejected, (state, action) => {
        state.jurisdictionList.isLoadingJurisdictionList = false;
        state.jurisdictionList.errorJurisdictionList = action.payload;
      });
  },
});

// Export reducer dan action
export const { setJurisdictionList } = jurisdictionSlice.actions;
export default jurisdictionSlice.reducer;
